import { CalendarClockIcon, Check, Euro, InboxIcon, PersonIcon, Star } from 'assets/icons';
import { wholeEuros } from 'pages/companies/recordItems';
import useText from 'hooks/useText';
import { RecordSection } from './RecordLayout';

/**
 * « Résultats » of the sales work with a company, as on the statistics of the
 * prototype, for this company alone: the appointments held, the requests that
 * came in, the sale, its revenue, the show-up and the closing, since `since`.
 */
const ResultsCard = ({ results, since }) => {
  const { text } = useText('record');
  const tiles = [
    [CalendarClockIcon, String(results.appointmentsHeld), text(results.appointmentsHeld > 1 ? 'resultsHeldMany' : 'resultsHeldOne')],
    [InboxIcon, String(results.requests), text(results.requests > 1 ? 'resultsRequestsMany' : 'resultsRequestsOne')],
    [Star, String(results.sales), text(results.sales > 1 ? 'resultsSalesMany' : 'resultsSalesOne')],
    [Euro, wholeEuros(results.revenue), text('resultsRevenue')],
    [PersonIcon, `${results.showUp} %`, text('resultsShowUp')],
    [Check, `${results.closing} %`, text('resultsClosing')],
  ];
  return (
    <RecordSection
      title={text('results')}
      action={<span className="text-xs text-gray-400">{since}</span>}
    >
      <div className="mt-2 grid grid-cols-2 gap-3 tab:grid-cols-3">
        {tiles.map(([Icon, value, label]) => (
          <div key={label} className="flex min-w-0 flex-col items-start gap-2 rounded-2xl border border-gray-100 bg-white p-4">
            <span className="flex h-8 w-8 items-center justify-center rounded-2xl bg-gray-100 text-gray-600">
              <Icon wh={16} color="currentColor" />
            </span>
            <p className="whitespace-nowrap text-xl font-bold leading-[26px] tracking-[-0.4px] text-gray-900">{value}</p>
            <p className="text-xs leading-4 text-gray-600">{label}</p>
          </div>
        ))}
      </div>
    </RecordSection>
  );
};

export default ResultsCard;
